module.exports = __webpack_public_path__ + "static/media/workpacks.d9998acc.svg";